import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import EnhancedTable from 'Shared/EnhancedTable';
import ReferencialContext from 'Shared/ReferencialContext';
import { columns } from './constants';
import Filters from './Filters/Filters';

const Products = () => {
  const history = useHistory();
  const {
    state: { referencial },
  } = useContext(ReferencialContext);
  const [productList, setProductList] = React.useState([]);
  const [values, setValues] = React.useState({ brand: [], family4: [] });

  const handleInputChange = (event) => {
    const { target: { name, value } } = event;
    setValues({ ...values, [name]: value });
  };
  useEffect(() => {
    if (referencial.products) {
      setProductList(
        referencial.products
          .filter((p) => p.iA)
          .filter((po) => (!values.search
            || (po.reference && po.reference.toLowerCase().includes(values.search.toLowerCase()))
            || (po.des && po.des.toLowerCase().includes(values.search.toLowerCase()))
            || (po.e && po.e.toLowerCase().includes(values.search.toLowerCase()))
            || (po.eF && po.eF.toLowerCase().includes(values.search.toLowerCase()))
            || (po.d && po.d.toLowerCase().includes(values.search.toLowerCase()))
            || (po.dimensions2
              && po.dimensions2.toLowerCase().includes(values.search.toLowerCase()))
            || (po.rO && po.rO.toLowerCase().includes(values.search.toLowerCase())))
            && (!values.family4.length || values.family4.map((f) => f.id).includes(po.fId))
            && (!values.brand.length || values.brand.map((b) => b.id).includes(po.bId)))
          .map((p) => ({ ...p, navigateSettings: () => history.push('/product-settings', p) })),
      );
    }
  }, [referencial.products, setProductList, values]);
  return (
    <>
      <Filters values={values} onChange={handleInputChange} />
      <EnhancedTable
        staticData
        rows={productList}
        headCells={columns}
        count={productList.length}
        rowsPerPageOptions={[10, 15, 20]}
      />
    </>
  );
};

export default Products;
